import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import InvoiceBodyRow from "./InvoiceBodyRow";
import {v4 as uuidv4} from 'uuid';

function InvoiceBodyContent(props) {

    const [rowItems, setRowItems] = useState([])
    const addRow = () => {
        setRowItems(prevRowItems => [...prevRowItems, {
            id: uuidv4(),
            invoiceId: props.invoiceId,
            itemId: 0,
            itemName: "",
            quantity: 0,
            price: 0.00,
            lastPrice: 0.00,
            stock: 0,
            total: 0,
            comment: ""
        }]);
    };
    useEffect(() => {
        if (props.contentList.length === 0) {
            setRowItems([{
                id: uuidv4(),
                invoiceId: props.invoiceId,
                itemId: 0,
                itemName: "",
                quantity: 0,
                price: 0.00,
                lastPrice: 0.00,
                stock: 0,
                total: 0.0,
                comment: ""
            }])
        } else {
            setRowItems(props.contentList);
        }
    }, [props.invoiceId, props.contentList])
    const deleteRow = (index) => {
        if (rowItems[index].itemName === "" && index === 0)
            return;
        const idx = rowItems[index].id;
        const filteredItems = (rowItems.filter(item => item.id !== idx))
        if (filteredItems.length === 0) {
            filteredItems.push({
                id: uuidv4(),
                invoiceId: props.invoiceId,
                itemId: 0,
                itemName: "",
                quantity: 0,
                price: 0.00,
                lastPrice: 0.00,
                stock: 0,
                total: 0,
                comment: ""
            })
        }
        setRowItems(filteredItems);
        props.setContentList(filteredItems);
    };
    const updateRow = (i, rItems) => {
        const newRowItems = [...rowItems];
        newRowItems[i] = rItems;
        setRowItems(newRowItems);
        props.setContentList(newRowItems);

    };
    return (
        <>
            {rowItems.map((rowItem, index) => (
                <InvoiceBodyRow
                    key={rowItem.id}
                    i={index}
                    thisLast={(rowItems.length - 1) === index}
                    globalEnable={props.globalEnable}
                    priceEnable={props.priceEnable}
                    cid={props.customerId}
                    rowItem={rowItem}
                    setAddButton={addRow}
                    setDeleteButton={() => deleteRow(index)}
                    setUpdateRow={(updatedItem) => updateRow(index, updatedItem)}
                    isApproved={props.isApproved}
                    isPosted={props.isPosted}
                    setLoading={props.setLoading}
                    loading={props.loading}
                    itemList={props.itemList}
                />

            ))}
        </>
    );
}

// Adding prop-types validation
InvoiceBodyContent.propTypes = {
    contentList: PropTypes.array.isRequired,
    setContentList: PropTypes.func.isRequired,

    priceEnable: PropTypes.bool.isRequired,
    customerId: PropTypes.number.isRequired,
    invoiceId: PropTypes.number.isRequired,
    isApproved: PropTypes.bool.isRequired,
    isPosted: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    itemList: PropTypes.array.isRequired,

};

export default InvoiceBodyContent;